const CORPORATE_ID = 5;
const CORPORATE_GUID = "3be688d8173f40b79a8aeba6e4758aa0";
const ANONYMIZATION_GUİD = "46401d86b0ea42179e830010497f83f0";
const CRM_PASSWORD = "A140CFD6-CB9A-EC11-A33B-005056B3A078";
const J_LANG_PARAM = "j-tr-tr";
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const ENABLED_STATE = "ENABLED";
const OTP_DURATION = 180;
const BRIDGE_BASE_URL = "/apps/apibridge/integration/path/";
const META_BASE_URL = "https://metadata.hollyconnect.com/";


const BASE_API_URL = 'https://shopify-api.jumbo.com.tr';
const BTPRO_API = {
        GET_STORE_STOCK: BASE_API_URL + '/api/v1/product/store-stock',
        GET_STORES: BASE_API_URL + '/api/v1/store', // magaza rehberi (shopifyId, ad, adres, il, telefon) — PDP "Bulundugu magazalar"
        GET_OTP: BASE_API_URL + '/api/v1/customer/request-otp',
        CHECK_OTP: BASE_API_URL + '/api/v1/customer/verify-otp',
        GET_MAIL_STATUS: BASE_API_URL + '/api/v1/customer/check-email',
        SEND_ACTIVATION_EMAIL: BASE_API_URL + '/api/v1/customer/send-activation',
        GET_TOKEN: BASE_API_URL + '/api/v1/customer/get-token',
        GET_FAVS:BASE_API_URL + '/api/v1/customer-favorites',
        ADD_FAV:BASE_API_URL + '/api/v1/customer-favorites',
        REMOVE_FAV:BASE_API_URL + '/api/v1/customer-favorites/remove',
        // GET_FAV_COUNT: BASE_API_URL + '/api/v1/customer-favorites/fav-count', // Ön yüzde kulanılmıyor
        UPDATE_USER: BASE_API_URL + '/api/v1/customer/update-profile-web',  
        DELETE_USER: BASE_API_URL + '/api/v1/customer/passive',
        GET_INSTALLMENT: BASE_API_URL + '/api/v1/order/installments',
        CONTACT_FORM:BASE_API_URL + '/api/v1/customer/request-form',
        GET_COUPONS: BASE_API_URL + '/api/v1/customer/discount-codes',
        LET_ME_KNOW: BASE_API_URL + '/api/v1/customer/stock-request-notify',
        CANCEL_REQUEST: BASE_API_URL + '/api/v1/order/cancel-request',
        RETURN_REQUEST: BASE_API_URL + '/api/v1/order/return-request',
        GET_GUEST_ORDER: BASE_API_URL + '/api/v1/order/guest-order',
        CANCEL_GUEST_ORDER: BASE_API_URL + '/api/v1/order/guest-cancel-request',
        RETURN_GUEST_ORDER: BASE_API_URL + '/api/v1/order/guest-return-request',
        CANCEL_REASONS: BASE_API_URL + '/api/v1/cancellation-reasons',
        RETURN_REASONS: BASE_API_URL + '/api/v1/return-reasons',
    }




// const HC_API = {
//     GET_OTP: BRIDGE_BASE_URL + "cm4gpe10o0002ounylne4o8bv",
//     GET_MAIL_STATUS: BRIDGE_BASE_URL + "cm4gp4rmh0002wbh9rgr3i666",
//     CHECK_OTP: BRIDGE_BASE_URL + "cm4gpfxyt00026a2wzsuuoh1c",
//     UPDATE_USER: BRIDGE_BASE_URL + "cm4gpjnmj000a6a2wpqj0n379", // not used
//     GET_CUSTOMER_DATA: BRIDGE_BASE_URL + "cm419g6fa00043slzxy2s0f63",
//     MOBILE_PHONE_CHECK_UPDATE: BRIDGE_BASE_URL + "cm4gpm0630002x4q0bvwqi2ll",
//     CODE_CHECK_UPDATE: BRIDGE_BASE_URL + "cm4gpo5oc0002bjba3lbbjerq",
//     SEND_ACTIVATION_MAIL: BRIDGE_BASE_URL + "cm4gppztp0004xeg7rxvdqjb7",
//     CUSTOMER_ANONYMIZATION: BRIDGE_BASE_URL + "cm4i5jui3000yslkarwz7miz3",
//     GET_COUPON: BRIDGE_BASE_URL + "cm4i5l8wn0015slkao9p8zvv1",
//     SET_CANCEL_RETURN: BRIDGE_BASE_URL + "cm4i5s813001dslkai2uj2p0m",
//     SET_CUSTOMER_ADDRESS: BRIDGE_BASE_URL + "cm4i5vval001lslkahr7jxd6s",
//     DEL_CUSTOMER_ADDRESS: BRIDGE_BASE_URL + "cm4i5y2fs001vslka51xgj10i",
//     SEND_CRM_FORM: BRIDGE_BASE_URL + "cm4i62dno0023slkak8mt1z2j",
//     GET_FAVS: BRIDGE_BASE_URL + "cm4i4blnz000aslkamyj05bzw",
//     SET_FAV: BRIDGE_BASE_URL + "cm4gqi0ew0004slkayjb7dae1",
//     GET_FAV_DETAIL: BRIDGE_BASE_URL + "cm4i4f2db000gslka23cjnkp8",
//     GET_INSTALLMENT: BRIDGE_BASE_URL + "cm4i64lkh002lslkax6az41dm",
//     GET_ORDER: BRIDGE_BASE_URL + "cm4i6a08t002qslkakym88uog",
//     GET_CITIES: META_BASE_URL + "provinces",
//     GET_DISTRICTS: META_BASE_URL + "districts/",
//     GET_NEIGHBORHOODS: META_BASE_URL + "neighborhoods/",
//     SEND_CORPORATE_SALE_FORM: BRIDGE_BASE_URL + "cm8rf1zyx000krtwwtbdpolyp",
// };



const OTP_RESPONSE_ENUM = {
    phone_not_found: "Telefon bulunamadı.",
    phone_not_valid: "Geçersiz telefon numarası.",
    phone_number_already_validated: "Bu telefon numarası ve email ile zaten doğrulama yapıldı. Lütfen müşteri hizmetleriyle iletişime geçin.",
    select_kvkk_consent_type: "Üyelik sözleşmesi ve Aydınlatma metnini onaylamalısınız.",
    already_exist_email: "Bu e-posta adresi zaten mevcut.",
    invalid_code: "SMS kodunuz geçerli değil.",
    code_timeout: "Kod süresi doldu!",
    try_again: "Hata! Lütfen sonra tekrar deneyin.",
    otp_sms_limit_exceeded: "Çok fazla değişiklik yaptınız. Lütfen daha sonra tekrar deneyin."
};

const STATUS = {
    LOADING: "loading",
    ERROR: "error",
    SUCCESS: "success"
};

const MONTH_OBJECT = [
    { name: "Ocak", value: "01", dayCount: 31 },
    { name: "Şubat", value: "02", dayCount: 28 },
    { name: "Mart", value: "03", dayCount: 31 },
    { name: "Nisan", value: "04", dayCount: 30 },
    { name: "Mayıs", value: "05", dayCount: 31 },
    { name: "Haziran", value: "06", dayCount: 30 },
    { name: "Temmuz", value: "07", dayCount: 31 },
    { name: "Ağustos", value: "08", dayCount: 31 },
    { name: "Eylül", value: "09", dayCount: 30 },
    { name: "Ekim", value: "10", dayCount: 31 },
    { name: "Kasım", value: "11", dayCount: 30 },
    { name: "Aralık", value: "12", dayCount: 31 }
];

const genderMap = { 1: "male", 2: "female", 3: "other" };
const genderCodeMap = { "male": 1, "female": 2, "other": 3 };
